export function assert(bool: boolean) {
  if (!bool) {
    throw new Error(`Assertion error`);
  }
}
